<template>
  <div class="custom-page-header">

    <!-- 内容区域 -->
    <button class="header-back-btn" type="button" @click="goBack">
      <span class="header-back-icon" aria-hidden="true">
        <el-icon>
          <ArrowLeft />
        </el-icon>
      </span>
      <span>返回</span>
    </button>

    <span class="header-divider" aria-hidden="true"></span>

    <div class="page-header-content">
      <div class="avatar-info">

        <div class="identity-card">

          <el-popover :width="360" trigger="hover" placement="bottom-start" popper-class="user-profile-popper">
            <template #reference>
              <button class="avatar-trigger" type="button">
                <el-avatar :src="userData.imageUrl" :size="56">
                  {{ userInitial }}
                </el-avatar>
              </button>
            </template>

            <template #default>
              <section class="profile-panel">
                <div class="profile-hero">
                  <div class="avatar-wrap">
                    <el-avatar :src="userData.imageUrl" :size="72">
                      {{ userInitial }}
                    </el-avatar>

                    <el-upload class="avatar-uploader" action="https://diagapi.wwftool.top/api/v1/user/myUploadFile"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :on-error="handleAvatarError"
                      :before-upload="beforeAvatarUpload" :headers="uploadHeaders">
                      <button class="avatar-upload-btn" type="button" title="上传头像">
                        <el-icon>
                          <Upload />
                        </el-icon>
                      </button>
                    </el-upload>
                  </div>

                  <div class="profile-summary">
                    <div class="profile-name-row">
                      <strong>{{ userData.username || '未设置名称' }}</strong>
                      <el-tag size="small" effect="dark" class="status-tag">
                        {{ userData.webstatus || 'USER' }}
                      </el-tag>
                    </div>
                    <div class="profile-subtitle">
                      {{ userData.job || '未设置岗位' }}
                    </div>
                  </div>
                </div>

                <div class="profile-actions">
                  <button class="profile-action" type="button" @click="dialogFormVisible2 = true">
                    <span class="action-icon">
                      <el-icon>
                        <EditPen />
                      </el-icon>
                    </span>
                    <span class="action-copy">
                      <strong>修改显示名称</strong>
                      <small>用于站点内展示和贡献者信息</small>
                    </span>
                  </button>

                  <button class="profile-action" type="button" @click="dialogFormVisible = true">
                    <span class="action-icon">
                      <el-icon>
                        <Lock />
                      </el-icon>
                    </span>
                    <span class="action-copy">
                      <strong>修改登录密码</strong>
                      <small>定期更新可以保护账号安全</small>
                    </span>
                  </button>
                </div>

                <div class="profile-footer">
                  <span>请勿泄露个人账号密码</span>
                  <el-button type="danger" plain size="small" :icon="SwitchButton" @click="handleLogout">
                    退出
                  </el-button>
                </div>

              </section>
            </template>
          </el-popover>

          <div class="avatar-text-container">
            <span class="header-kicker">{{ currentGreeting }} · {{ brandSlogan }}</span>
            <div class="identity-line">
              <strong class="username">{{ userData.username || '未设置名称' }}</strong>
              <el-tag size="small" effect="dark" class="inline-status">
                {{ userData.webstatus || 'USER' }}
              </el-tag>
            </div>
            <div class="identity-meta">
              <span>{{ userData.job || '未设置岗位' }}</span>
              <i></i>
              <span>{{ routeTitle }}</span>
            </div>
          </div>

        </div>

      </div>
    </div>

    <!-- 右侧功能 -->
    <div class="page-header-extra">

      <!-- PC -->
      <el-segmented v-if="!isMobile" class="header-segment" v-model="val1" :options="headerOptions" size="large"
        @change="handleSegmentChange" />

      <!-- Mobile -->
      <el-dropdown v-else trigger="click" @command="handleSegmentChange">
        <el-button class="mobile-menu-btn">
          webford
        </el-button>

        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="item in headerOptions"
              :key="item.value"
              :command="item.value"
              :disabled="item.disabled"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <Drawerlog v-model="showDrawer" />
      <ApiAnalysis v-model="showApiAnalysis" />
      <QuerySettings v-model="showQuerySettings" />

    </div>

  </div>

  <!-- 修改用户名 -->
  <el-dialog v-model="dialogFormVisible2" title="修改站点显示名称" width="460px" class="profile-dialog">
    <el-form label-position="top">
      <el-form-item label="当前:">
        <el-input v-model="userData.username" disabled />
      </el-form-item>
      <el-form-item label="修改:">
        <el-input v-model="NewName" placeholder="请输入新的显示名称" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogFormVisible2 = false">取消</el-button>
      <el-button type="primary" @click="handleChangeName">提交</el-button>
    </template>
  </el-dialog>

  <!-- 修改密码 -->
  <el-dialog v-model="dialogFormVisible" title="修改密码" width="460px" class="profile-dialog">
    <el-form label-position="top">
      <el-form-item label="当前密码:">
        <el-input v-model="NewPW.oldPW" type="password" show-password placeholder="请输入当前密码" />
      </el-form-item>
      <el-form-item label="新密码:">
        <el-input v-model="NewPW.NewPW1" type="password" show-password placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="确认密码:">
        <el-input v-model="NewPW.NewPW2" type="password" show-password placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="dialogFormVisible = false">取消</el-button>
      <el-button type="primary" @click="handleChangePassword">提交</el-button>
    </template>
  </el-dialog>

</template>

<script>
import { ref, reactive, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Drawerlog from './Drawerlog.vue'
import ApiAnalysis from './ApiAnalysis.vue'
import QuerySettings from './QuerySettings.vue'
import { ArrowLeft, EditPen, Lock, SwitchButton, Upload } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { userSaveName, userSavePassword } from '../api/users'
import { clearAuthCache } from '../router/index'
import { topEntryState } from '@/utils/adminAccess.mjs'

export default {

  components: {
    Drawerlog,
    ApiAnalysis,
    QuerySettings,
    ArrowLeft,
    EditPen,
    Lock,
    SwitchButton,
    Upload
  },

  setup() {

    /* 移动端识别 */
    const isMobile = ref(window.innerWidth <= 768)

    const handleResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })

    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    const userData = ref(JSON.parse(JSON.stringify(store.state.userData)))

    const userInitial = ref((userData.value.username || 'U').slice(0, 1).toUpperCase())

    const val1 = ref('webford')

    const options = [
      { label: 'webford', value: 'webford' },
      { label: '在线接口类型解析', value: '1' },
      { label: '接口文档', value: '2' },
      { label: '更新内容', value: '3' },
      { label: '查询设置', value: '4' }
    ]

    const headerOptions = computed(() => options.map((item) => ({
      ...item,
      disabled: topEntryState(store.state.userData, item.value) === 'disabled'
    })))

    const headerSlogansMoreMap = {
      morning: [
        '早安，愿今日需求清晰，Bug 自闭，工资好运到账',
        '今日开工大吉，愿你写啥都过，点啥都成',
        '新的一天，愿你少改需求，多遇贵人',
        '工位已开光，今日适合升职、加薪、少背锅',
        '愿你今天接口畅通，心情顺滑，老板失忆',
        '今日宜开工，宜摸鱼，宜突然收到好消息',
        '祝你今天键盘生风，代码有神，会议取消',
        '打工人今日运势：大吉大利，需求远离你'
      ],

      noon: [
        '午间大吉，愿你外卖准时，下午无会',
        '吃饱喝足，愿下午 Bug 自己投降',
        '午休回血成功，愿你醒来就有好事发生',
        '今日碳水护体，坏需求退散',
        '愿这顿饭吃完，烦恼清零，工资翻倍',
        '中午补能大吉，下午只摸鱼不背锅',
        '饭已到位，好运加载中',
        '愿你下午顺风顺水，群里无人找你'
      ],

      afternoon: [
        '下午大吉，愿所有问题都有别人负责',
        '愿你今日进度拉满，锅从身边绕行',
        '好运正在编译，请保持工位在线',
        '愿你一查就准，一改就过，一问三不归你',
        '下午宜破局，宜收尾，宜突然被夸',
        '愿需求停止变异，方案一路绿灯',
        '今日福气已同步，异常自动退散',
        '愿你下午不被点名，不被催更，不被拉会'
      ],

      evening: [
        '晚上大吉，愿你准点下班，路上有风，心里有钱',
        '今日收工大吉，愿问题封印成功',
        '愿你今晚无加班，明日无返工',
        '好事发生中，请打工人安全撤离公司副本',
        '愿今天所有破事到此为止，明天只收好消息',
        '下班大吉，愿工资涨，烦恼降，老板少讲话',
        '今日副本通关，奖励：平安下班',
        '愿你带着好运回家，不带着需求回家'
      ],

      night: [
        '深夜大吉，愿 Bug 消失，需求沉睡，你也早点睡',
        '愿今晚没有临时消息，没有线上事故，只有好运降临',
        '夜间护体符已生效：坏需求不得靠近',
        '大吉大利，今晚不加班，明天有好事',
        '愿你深夜少熬一点，福气多来一点',
        '当前好运值拉满，建议保存进度并撤退',
        '愿所有问题今晚自动过期',
        '别硬撑了，好运也喜欢早睡的人'
      ]
    }

    const homeSlogansMoreMap = {
      night: [
        '我在深夜连接车辆，车辆沉默，日志发疯',
        '当城市熄火，打工人的诊断链路仍在保持',
        '7F 78 让我等等，老板也让我等等',
        'VIN 是 17 位，牛马的命也是被编码的',
        '今夜不清码，明日必返场',
        'ECU 可以休眠，我不能，因为需求还醒着',
        '深夜的 CAN 报文，比老板的消息还准时',
        '故障码不会骗人，但需求文档会',
        '我以断点审判 Bug，以咖啡续写人生',
        '日志滚动的声音，是牛马最后的倔强',
        '刷写失败不可怕，可怕的是客户说刚刚还能用',
        '车还没启动，我的血压先启动了',
        '夜深人静，只有异常栈在陪我说话',
        '一个 0x7F，击穿了我全部防线',
        '别问我为什么没睡，我在等 ECU 回正响应'
      ],

      morning: [
        '点火，上班，连接人生 OBD',
        '启动今日诊断会话',
        '以 VIN 为证，以日志为据',
        '今日目标：让故障码清空，让工资到账',
        '福特在线，牛马上线',
        '主线程已启动，副线程还在赖床',
        '咖啡注入成功，人体 ECU 恢复通信',
        '今天也要精准命中 Deliver',
        '早上第一件事：确认昨天的 Bug 不是梦',
        '编译通过，是打工人最朴素的幸福',
        'CAN 线通不通不知道，怨气肯定通了',
        '车辆进入诊断模式，我进入牛马模式',
        '读取 VIN，识别车型，顺便识别命运',
        '接口一响，黄金万两；接口一炸，全员爆炸',
        '让 DTC 消失，让客户微笑，让自己别猝倒'
      ],

      noon: [
        '午饭是人体 ECU 的基础标定',
        '主线程申请阻塞等待：吃饭',
        '碳水不足，无法进入扩展会话',
        '暂停 Debug，执行打工人回血流程',
        '午间 GC：回收疲劳、释放怨气',
        '车要保养，人要吃饱',
        '饭点不积极，下午报 P0000：灵魂缺失',
        '打工人低电压，请连接外部电源',
        '别让饥饿影响判断 ECU 是否离线',
        '暂停刷写，避免把饭点也刷没了',
        '今天的午饭，是对抗需求变更的燃料',
        '吃完再修，别把自己修坏了',
        '午休不是偷懒，是系统保护策略',
        '人体冷却液不足，请补充快乐水',
        '饭后再战，故障码跑不了'
      ],

      afternoon: [
        '异常栈已展开，真相即将浮现',
        '诊断不是玄学，但有时候比玄学还玄',
        '我将用日志照亮 ECU 的沉默',
        '故障码只是表象，锅才是真相',
        '下午的我，像满载 Transit 一样沉重',
        '数据流穿过 CAN 总线，答案正在靠近',
        '断点落下之处，Bug 无所遁形',
        '我重构的不是代码，是混乱的人生',
        '每一次 0x22 请求，都是对车辆灵魂的拷问',
        '让接口保持沉默，让结果开始说话',
        '福特的模块很多，打工人的借口更少',
        '需求像故障码一样，清了还会再来',
        '我不怕报错，我怕没有日志',
        '今日份逻辑闭环正在生成',
        '只要还能收到正响应，就还没输'
      ],

      evening: [
        '最后一次编译，不一定真的是最后一次',
        '收工前的 Bug，最擅长伪装成小问题',
        '夜色已深，需求仍在变更',
        '加班不是荣耀，稳定才是王道',
        '提交之前，先确认自己还在线',
        '代码可以明天改，人最好今天休息',
        '别和 Bug 同归于尽',
        '今天的故障先挂起，明天继续清码',
        '打工人的一天，从点火开始，到熄火结束',
        'ECU 已休眠，老板还在唤醒',
        '今日工况：高负载、低电量、轻微异响',
        '别再开新分支了，人生已经够分裂了',
        '下班不是逃避，是系统正常关机',
        '别把自己跑成常发故障',
        '今晚不建议继续进入编程会话'
      ]
    }

    const getTimePeriod = () => {
      const hour = new Date().getHours()
      if (hour < 6) return 'night'
      if (hour < 12) return 'morning'
      if (hour < 14) return 'noon'
      if (hour < 18) return 'afternoon'
      if (hour < 22) return 'evening'
      return 'night'
    }

    const randomPick = (list) => list[Math.floor(Math.random() * list.length)]
    const sloganCacheKey = 'webford-page-header-slogans'

    const getStableSlogans = () => {
      const period = getTimePeriod()

      try {
        const cached = JSON.parse(localStorage.getItem(sloganCacheKey) || 'null')
        if (
          cached &&
          cached.period === period &&
          cached.brandSlogan &&
          cached.homeSlogan
        ) {
          return cached
        }
      }
      catch {
        localStorage.removeItem(sloganCacheKey)
      }

      const next = {
        period,
        brandSlogan: randomPick(headerSlogansMoreMap[period]),
        homeSlogan: randomPick(homeSlogansMoreMap[period])
      }

      localStorage.setItem(sloganCacheKey, JSON.stringify(next))
      return next
    }

    const stableSlogans = getStableSlogans()
    const brandSlogan = ref(stableSlogans.brandSlogan)
    const homeSlogan = ref(stableSlogans.homeSlogan)

    const currentGreeting = computed(() => {
      const hour = new Date().getHours()

      if (hour < 6) return '夜间维护'
      if (hour < 12) return '上午好'
      if (hour < 14) return '中午好'
      if (hour < 18) return '下午好'
      if (hour < 22) return '晚上好'
      return '夜深了'
    })

    const routeTitle = computed(() => homeSlogan.value)

    const updateSegment = () => {
      const path = route.path

      if (path.startsWith('/apidoc')) {
        val1.value = '2'
      }
      else if (path === '/') {
        val1.value = 'webford'
      }
    }

    onMounted(() => {
      updateSegment()
    })

    watch(() => route.path, () => {
      updateSegment()
    })

    const showDrawer = ref(false)
    const showApiAnalysis = ref(false)
    const showQuerySettings = ref(false)

    const dialogFormVisible = ref(false)
    const dialogFormVisible2 = ref(false)

    const NewName = ref('')

    const NewPW = reactive({
      oldPW: '',
      NewPW1: '',
      NewPW2: ''
    })

    const uploadHeaders = ref({
      Authorization: 'Bearer ' + localStorage.getItem("authToken")
    })

    const handleSegmentChange = (value) => {

      if (topEntryState(store.state.userData, value) === 'disabled') {
        val1.value = 'webford'
        ElMessage.warning('当前账号无此入口权限')
        return
      }

      val1.value = value

      if (value === '2') {
        router.push('/apidoc')
      }
      else if (value === '3') {
        showDrawer.value = true
      }
      else if (value === '1') {
        showApiAnalysis.value = true
      }
      else if (value === '4') {
        showQuerySettings.value = true
      }
      else {
        router.push('/')
      }

    }

    const handleChangeName = async () => {

      dialogFormVisible2.value = false

      try {

        const res = await userSaveName({
          username: NewName.value
        })

        store.commit('setUserData', res.data.userInfo)

        userData.value = res.data.userInfo
        userInitial.value = (userData.value.username || 'U').slice(0, 1).toUpperCase()

        ElMessage.success('设置成功')

      }
      catch {

        ElMessage.error('设置失败')

      }

    }

    const handleChangePassword = async () => {

      dialogFormVisible.value = false

      if (!NewPW.oldPW || !NewPW.NewPW1 || !NewPW.NewPW2) {
        ElMessage.error('请填写完整')
        return
      }

      if (NewPW.NewPW1 !== NewPW.NewPW2) {
        ElMessage.error('新密码不一致')
        return
      }

      try {

        await userSavePassword(NewPW)

        ElMessage.success('设置成功')

      }
      catch {

        ElMessage.error('设置失败')

      }

      NewPW.oldPW = ''
      NewPW.NewPW1 = ''
      NewPW.NewPW2 = ''

    }

    const handleLogout = () => {

      ElMessageBox.confirm('确定退出当前账号吗？', '退出登录')
        .then(() => {

          localStorage.clear()

          clearAuthCache()

          router.replace({ name: 'LoginView' })

          ElMessage.success('已退出登录')

        })

    }

    const handleAvatarSuccess = (res) => {

      userData.value.imageUrl = res.imageUrl
      store.commit('setUserData', {
        ...store.state.userData,
        imageUrl: res.imageUrl
      })

      ElMessage.success('头像上传成功')

    }

    const handleAvatarError = () => {

      ElMessage.error('头像上传失败')

    }

    const beforeAvatarUpload = (file) => {

      const isValid = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isValid) {
        ElMessage.error('仅支持 JPG/PNG')
        return false
      }

      if (file.size / 1024 / 1024 > 2) {
        ElMessage.error('不能超过2MB')
        return false
      }

      return true

    }

    const goBack = () => {

      if (window.history.length > 1) {
        router.back()
      } else {
        router.push('/login')
      }

    }

    return {

      isMobile,
      userData,
      userInitial,
      currentGreeting,
      brandSlogan,
      routeTitle,
      val1,
      options,
      headerOptions,
      showDrawer,
      showApiAnalysis,
      showQuerySettings,
      dialogFormVisible,
      dialogFormVisible2,
      NewName,
      NewPW,
      uploadHeaders,
      handleSegmentChange,
      handleChangeName,
      handleChangePassword,
      handleLogout,
      handleAvatarSuccess,
      handleAvatarError,
      beforeAvatarUpload,
      goBack,
      SwitchButton

    }

  }

}
</script>

<style scoped>
.custom-page-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-back-btn {
  height: 42px;
  min-width: 78px;
  padding: 0 14px 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  border: 1px solid rgba(203, 213, 225, 0.9);
  border-radius: 999px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  color: #0f172a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.header-back-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(34, 211, 238, 0.8);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
}

.header-back-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #ecfeff;
  color: #0891b2;
}

.header-divider {
  width: 1px;
  height: 28px;
  background: rgba(203, 213, 225, 0.8);
  flex: 0 0 auto;
}

.page-header-content {
  min-width: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.page-header-extra {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 0;
  margin-left: auto;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.avatar-info {
  display: flex;
  align-items: center;
}

.identity-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 290px;
  padding: 6px 16px 6px 0;
  border-radius: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.identity-card::before {
  display: none;
}

.avatar-trigger {
  position: relative;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  cursor: pointer;
  line-height: 0;
  box-shadow: 0 0 0 3px rgba(34, 211, 238, 0.22), 0 12px 28px rgba(15, 23, 42, 0.18);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.avatar-trigger:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 4px rgba(34, 211, 238, 0.34), 0 16px 34px rgba(15, 23, 42, 0.22);
}

.avatar-trigger :deep(.el-avatar) {
  border: 2px solid #ffffff;
  font-weight: 800;
}

.avatar-text-container {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  gap: 5px;
  min-width: 0;
  padding-left: 8px;
}

.header-kicker {
  color: #0f766e;
  font-size: 11px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0;
}

.identity-line {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.username {
  color: #0f172a;
  font-size: 18px;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-status {
  flex: 0 0 auto;
  border: 0;
  background: #0f172a;
  color: #ffffff;
  font-weight: 700;
}

.identity-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.identity-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.identity-meta i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #22c55e;
  flex: 0 0 auto;
}

.mobile-menu-btn {
  height: 40px;
  border: 0 !important;
  border-radius: 12px !important;
  background: linear-gradient(135deg, #facc15 0%, #f59e0b 100%) !important;
  color: #1f2937 !important;
  font-weight: 700;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.48), 0 10px 22px rgba(180, 83, 9, 0.18);
}

:deep(.header-segment) {
  --el-segmented-bg-color: #f3f6fa;
  --el-segmented-item-selected-bg-color: #facc15;
  --el-segmented-item-selected-text-color: #111827;
  --el-border-radius-base: 14px;
  padding: 5px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92), 0 10px 24px rgba(15, 23, 42, 0.06);
}

:deep(.header-segment .el-segmented__item) {
  min-height: 36px;
  padding: 0 12px;
  font-weight: 700;
  color: #334155;
  border-radius: 11px;
  transition: color 0.18s ease, background-color 0.18s ease, transform 0.18s ease;
}

:deep(.header-segment .el-segmented__item:hover) {
  color: #111827;
  background: rgba(255, 251, 235, 0.86);
  transform: translateY(-1px);
}

:deep(.header-segment .el-segmented__item.is-selected) {
  background: linear-gradient(135deg, #fde047 0%, #facc15 48%, #f59e0b 100%);
  color: #111827;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 8px 18px rgba(180, 83, 9, 0.18);
}

:deep(.header-segment .el-segmented__item-selected) {
  background: linear-gradient(135deg, #fde047 0%, #facc15 48%, #f59e0b 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 8px 18px rgba(180, 83, 9, 0.18);
}

:global(.user-profile-popper.el-popper) {
  padding: 0 !important;
  border: 1px solid rgba(226, 232, 240, 0.95) !important;
  border-radius: 14px !important;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.profile-panel {
  background: #ffffff;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #fff7cc 0%, #ffffff 58%, #eef6ff 100%);
  border-bottom: 1px solid #edf2f7;
}

.avatar-wrap {
  position: relative;
  flex: 0 0 auto;
}

.avatar-wrap :deep(.el-avatar) {
  border: 3px solid #ffffff;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.16);
  font-size: 24px;
  font-weight: 700;
}

.avatar-uploader {
  position: absolute;
  right: -2px;
  bottom: -2px;
  line-height: 0;
}

.avatar-upload-btn {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #111827;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.2);
  transition: transform 0.18s ease, background-color 0.18s ease;
}

.avatar-upload-btn:hover {
  transform: translateY(-1px);
  background: #000000;
}

.profile-summary {
  min-width: 0;
  flex: 1;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.profile-name-row strong {
  color: #111827;
  font-size: 18px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-tag {
  border: 0;
  background: #111827;
  color: #ffffff;
  flex: 0 0 auto;
}

.profile-subtitle {
  margin-top: 6px;
  color: #64748b;
  font-size: 13px;
}

.profile-actions {
  padding: 10px;
}

.profile-action {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.profile-action:hover {
  background: #f8fafc;
  transform: translateY(-1px);
}

.action-icon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #0f172a;
  flex: 0 0 auto;
}

.action-copy {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.action-copy strong {
  color: #111827;
  font-size: 14px;
  line-height: 1.25;
}

.action-copy small {
  color: #64748b;
  font-size: 12px;
  line-height: 1.35;
}

.profile-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
  color: #64748b;
  font-size: 12px;
}

.profile-dialog :deep(.el-dialog) {
  border-radius: 14px;
  overflow: hidden;
}

.profile-dialog :deep(.el-dialog__header) {
  margin: 0;
  padding: 18px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.profile-dialog :deep(.el-dialog__body) {
  padding: 20px;
}

.profile-dialog :deep(.el-dialog__footer) {
  padding: 0 20px 20px;
}

.profile-dialog :deep(.el-input__wrapper) {
  border-radius: 10px;
}

@media (max-width: 768px) {

  .custom-page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-divider {
    display: none;
  }

  .page-header-extra {
    width: 100%;
    margin-left: 0;
    justify-content: flex-start;
  }

  .profile-footer {
    align-items: flex-start;
    flex-direction: column;
  }

}
</style>
